// extracted by mini-css-extract-plugin
export default {"container":"tim_1EIJ8"};